// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"108":"49d82438","168":"b2d07b66"}[chunkId] + ".chunk.css";
};